import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    VForm,
    {
      ref: "form",
      staticClass: "create-attribute-form",
      attrs: { "lazy-validation": "" },
      model: {
        value: _vm.valid,
        callback: function ($$v) {
          _vm.valid = $$v
        },
        expression: "valid",
      },
    },
    [
      _c(
        "div",
        { staticClass: "form-section" },
        [
          _c("div", { staticClass: "section-title" }, [
            _vm._v(_vm._s(_vm.$t("create_attribute.sections.basic_info"))),
          ]),
          _c(
            VRow,
            { attrs: { dense: "" } },
            [
              _c(
                VCol,
                { attrs: { cols: "12", md: "6" } },
                [
                  _c("div", { staticClass: "field-label" }, [
                    _vm._v(_vm._s(_vm.$t("create_attribute.form.use_case"))),
                  ]),
                  _c(VSelect, {
                    attrs: {
                      outlined: "",
                      "hide-details": "auto",
                      dense: "",
                      items: _vm.useCases,
                      "item-text": "business_name",
                      "return-object": "",
                      rules: _vm.rules.use_case,
                      loading: _vm.loadingUseCases,
                    },
                    model: {
                      value: _vm.form.use_case,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "use_case", $$v)
                      },
                      expression: "form.use_case",
                    },
                  }),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "12", md: "6" } },
                [
                  _c("div", { staticClass: "field-label" }, [
                    _vm._v(
                      _vm._s(_vm.$t("create_attribute.form.nombre_tabla"))
                    ),
                  ]),
                  _c(VTextField, {
                    attrs: {
                      outlined: "",
                      "hide-details": "auto",
                      dense: "",
                      rules: _vm.rules.nombre_tabla,
                      hint: _vm.$t("create_attribute.form.nombre_tabla_hint"),
                      "persistent-hint": "",
                      placeholder: "mi_tabla",
                      prefix: "sand_ibk_attr_",
                    },
                    model: {
                      value: _vm.form.nombre_tabla,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "nombre_tabla", $$v)
                      },
                      expression: "form.nombre_tabla",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "form-section" },
        [
          _c("div", { staticClass: "section-title" }, [
            _vm._v(_vm._s(_vm.$t("create_attribute.form.periods"))),
          ]),
          _c(
            VRow,
            { attrs: { dense: "", align: "start" } },
            [
              _c(
                VCol,
                { attrs: { cols: "12", sm: "4" } },
                [
                  _c(VSelect, {
                    attrs: {
                      label: _vm.$t("create_attribute.form.month"),
                      items: _vm.months,
                      "item-text": "name",
                      "item-value": "value",
                      outlined: "",
                      "hide-details": "auto",
                      dense: "",
                    },
                    model: {
                      value: _vm.selectedMonth,
                      callback: function ($$v) {
                        _vm.selectedMonth = $$v
                      },
                      expression: "selectedMonth",
                    },
                  }),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "12", sm: "4" } },
                [
                  _c(VSelect, {
                    attrs: {
                      label: _vm.$t("create_attribute.form.year"),
                      items: _vm.years,
                      "item-text": "name",
                      "item-value": "value",
                      outlined: "",
                      "hide-details": "auto",
                      dense: "",
                    },
                    model: {
                      value: _vm.selectedYear,
                      callback: function ($$v) {
                        _vm.selectedYear = $$v
                      },
                      expression: "selectedYear",
                    },
                  }),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "12", sm: "4" } },
                [
                  _c(
                    VBtn,
                    {
                      attrs: {
                        block: "",
                        color: "primary",
                        disabled:
                          !_vm.selectedMonth ||
                          !_vm.selectedYear ||
                          _vm.chips.length >= _vm.maxChips,
                      },
                      on: { click: _vm.addChip },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("create_attribute.form.add_period")) +
                          " "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                VCol,
                { attrs: { cols: "12" } },
                [
                  _c(
                    VChipGroup,
                    { attrs: { column: "" } },
                    _vm._l(_vm.chips, function (chip, index) {
                      return _c(
                        VChip,
                        {
                          key: chip.id,
                          staticClass: "caption",
                          attrs: { color: "primary", close: "" },
                          on: {
                            "click:close": function ($event) {
                              return _vm.removeChip(index)
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(chip.display) + " ")]
                      )
                    }),
                    1
                  ),
                  _vm.chipsError
                    ? _c(
                        "p",
                        { staticClass: "error--text caption mt-1 mb-0" },
                        [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t("create_attribute.rules.period_required")
                              ) +
                              " "
                          ),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "form-section" },
        [
          _c("div", { staticClass: "section-title" }, [
            _vm._v(_vm._s(_vm.$t("create_attribute.form.table_description"))),
          ]),
          _c(VTextarea, {
            attrs: {
              outlined: "",
              dense: "",
              rows: "3",
              placeholder: _vm.$t(
                "create_attribute.form.table_description_placeholder"
              ),
              rules: _vm.rules.table_description,
              counter: "500",
              maxlength: "500",
              "hide-details": "auto",
            },
            model: {
              value: _vm.form.table_description,
              callback: function ($$v) {
                _vm.$set(_vm.form, "table_description", $$v)
              },
              expression: "form.table_description",
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "form-section" },
        [
          _c("div", { staticClass: "section-title" }, [
            _vm._v(_vm._s(_vm.$t("create_attribute.sections.sql_script"))),
          ]),
          _c(
            VCard,
            { staticClass: "card-bulk pa-4", attrs: { outlined: "" } },
            [
              _c(
                "div",
                {
                  on: {
                    dragover: function ($event) {
                      $event.preventDefault()
                    },
                    drop: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "drag-file text-center pointer",
                      class: { "drag-active": _vm.isDragging },
                      on: {
                        drop: _vm.dropFile,
                        dragenter: function ($event) {
                          _vm.isDragging = true
                        },
                        dragleave: function ($event) {
                          _vm.isDragging = false
                        },
                      },
                    },
                    [
                      !_vm.form.script_file
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "d-flex flex-column align-center pt-3",
                            },
                            [
                              _c(VImg, {
                                attrs: {
                                  width: "56px",
                                  src: require("@/assets/sql_icon.png"),
                                },
                              }),
                              _c("p", { staticClass: "mt-2 mb-0" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("create_attribute.form.drag_file")
                                  )
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(VFileInput, {
                        staticClass: "upload-input-file pointer",
                        attrs: {
                          accept: ".sql",
                          chips: "",
                          placeholder: _vm.$t(
                            "create_attribute.form.attach_file"
                          ),
                          "prepend-icon": "",
                          "show-size": "",
                          "truncate-length": "50",
                          solo: "",
                          flat: "",
                          rules: _vm.rules.file,
                        },
                        on: { change: _vm.onFileSelected },
                        model: {
                          value: _vm.form.script_file,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "script_file", $$v)
                          },
                          expression: "form.script_file",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ]
          ),
          _vm.form.script_file
            ? _c(
                VAlert,
                {
                  staticClass: "mt-3 mb-0",
                  attrs: { type: "info", outlined: "", dense: "" },
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm.$t("create_attribute.form.async_info")) +
                      " "
                  ),
                ]
              )
            : _vm._e(),
          _vm.parseErrors.length > 0
            ? _c(
                VAlert,
                {
                  staticClass: "mt-3 mb-0",
                  attrs: { type: "error", outlined: "", dense: "" },
                },
                [
                  _c("div", { staticClass: "font-weight-bold mb-1" }, [
                    _vm._v(
                      "Errores en el archivo SQL — corregir antes de continuar:"
                    ),
                  ]),
                  _c(
                    "ul",
                    { staticClass: "mb-0" },
                    _vm._l(_vm.parseErrors, function (err, i) {
                      return _c("li", { key: i }, [_vm._v(_vm._s(err))])
                    }),
                    0
                  ),
                ]
              )
            : _vm._e(),
          _vm.partitionValidation
            ? _c("partition-validation-errors", {
                staticClass: "mt-3",
                attrs: { validation: _vm.partitionValidation },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }